// extracted by mini-css-extract-plugin
module.exports = {"signup_complete_container":"SignupCompletePage_signup_complete_container__BpP3_","confetti":"SignupCompletePage_confetti__272Ar","checked":"SignupCompletePage_checked__300bB"};